module.exports = __webpack_public_path__ + "static/media/DimensionConversion_001.dd997225.jpg";